import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { ref: "widget" }
const _hoisted_2 = ["data-fit"]
const _hoisted_3 = {
  key: 0,
  class: "FitText"
}
const _hoisted_4 = { class: "BestFitLogo" }
const _hoisted_5 = {
  key: 0,
  class: "PlusIcon lnr-plus-inverted"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.incentiveClicked && _ctx.incentiveClicked(...args))),
      "data-fit": _ctx.fitText,
      class: "ButtonHeaderWidget js-Widget"
    }, [
      (_ctx.hasEmptyText || (_ctx.isFullProfile && _ctx.userLoggedIn))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.fitText), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("i", {
          class: _normalizeClass(["BestFitIcon lnr-bestfit-logo", { 'is-animated': !_ctx.isFullProfile && _ctx.isAnimated }])
        }, null, 2 /* CLASS */),
        (!_ctx.isFullProfile || !_ctx.userLoggedIn)
          ? (_openBlock(), _createElementBlock("i", _hoisted_5))
          : _createCommentVNode("v-if", true)
      ])
    ], 8 /* PROPS */, _hoisted_2)
  ], 512 /* NEED_PATCH */))
}